var React = require('react');

function AccordianRemove (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/accordian-remove"),React.createElement("g",{"id":"icon/accordian-remove","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"ic_remove_circle_outline_24px","fill":"#1D1655","fillRule":"nonzero"},React.createElement("path",{"d":"M8,14.4 L8,17.6 L24,17.6 L24,14.4 L8,14.4 Z M16,0 C7.168,0 0,7.168 0,16 C0,24.832 7.168,32 16,32 C24.832,32 32,24.832 32,16 C32,7.168 24.832,0 16,0 Z M16,28.8 C8.944,28.8 3.2,23.056 3.2,16 C3.2,8.944 8.944,3.2 16,3.2 C23.056,3.2 28.8,8.944 28.8,16 C28.8,23.056 23.056,28.8 16,28.8 Z","id":"Shape"})))]);
}

AccordianRemove.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = AccordianRemove;

AccordianRemove.default = AccordianRemove;
